<template>
  <BaseView>
    <AdvicePractices />
  </BaseView>
</template>

<script setup lang="ts">
import AdvicePractices from '@/app/views/Services/AdvicePractices.vue'
import BaseView from '@/views/BaseView.vue'
</script>
